import {
  formatLastUpdated,
  LastUpdatedRow,
} from "../../../../../utils/tableUtil";

// Use 24-hour format so the string sorts lexicographically (YYYY-MM-DD HH:mm).
// 12-hour format breaks string sort: "09:xx AM" > "03:xx PM" lexicographically
// even though PM is later in actual time.
const SORTABLE_DATE_FORMAT = "YYYY-MM-DD HH:mm";

/**
 * Data normalizer to prepare field.values with transform values. This practice allows filtering
 * to be effective in calculated values
 * @param  {Array} dataset                dataset to map
 * @param  {string} timezone               time zone code
 * @return {Array}          normalized array
 */
export const dataNormalizer = (
  dataset: Record<string, unknown>[],
  timezone: string,
) => {
  return dataset.map((record) => {
    const normalRecord = { ...record };
    if (normalRecord.lastUpdated) {
      normalRecord.lastUpdated = formatLastUpdated(
        normalRecord as LastUpdatedRow,
        timezone,
        SORTABLE_DATE_FORMAT,
      );
    }

    return normalRecord;
  });
};
